/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Dashboard } from '../models/dashboard';
import { DataPageOfPatient } from '../models/data-page-of-patient';
import { DataPageOfSignificantEvents } from '../models/data-page-of-significant-events';
import { Patient } from '../models/patient';
import { patientGetDashboardList } from '../fn/patient/patient-get-dashboard-list';
import { PatientGetDashboardList$Params } from '../fn/patient/patient-get-dashboard-list';
import { patientGetFormatedPhoneNumber } from '../fn/patient/patient-get-formated-phone-number';
import { PatientGetFormatedPhoneNumber$Params } from '../fn/patient/patient-get-formated-phone-number';
import { patientGetPatientDetails } from '../fn/patient/patient-get-patient-details';
import { PatientGetPatientDetails$Params } from '../fn/patient/patient-get-patient-details';
import { patientGetPatientImage } from '../fn/patient/patient-get-patient-image';
import { PatientGetPatientImage$Params } from '../fn/patient/patient-get-patient-image';
import { patientGetSignificantList } from '../fn/patient/patient-get-significant-list';
import { PatientGetSignificantList$Params } from '../fn/patient/patient-get-significant-list';
import { patientSearch } from '../fn/patient/patient-search';
import { PatientSearch$Params } from '../fn/patient/patient-search';

@Injectable({ providedIn: 'root' })
export class PatientService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `patientSearch()` */
  static readonly PatientSearchPath = '/patient/Search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientSearch$Response(params?: PatientSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfPatient>> {
    return patientSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientSearch(params?: PatientSearch$Params, context?: HttpContext): Observable<DataPageOfPatient> {
    return this.patientSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfPatient>): DataPageOfPatient => r.body)
    );
  }

  /** Path part for operation `patientGetPatientDetails()` */
  static readonly PatientGetPatientDetailsPath = '/patient/GetPatientDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientGetPatientDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientGetPatientDetails$Response(params?: PatientGetPatientDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<Patient>> {
    return patientGetPatientDetails(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientGetPatientDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientGetPatientDetails(params?: PatientGetPatientDetails$Params, context?: HttpContext): Observable<Patient> {
    return this.patientGetPatientDetails$Response(params, context).pipe(
      map((r: StrictHttpResponse<Patient>): Patient => r.body)
    );
  }

  /** Path part for operation `patientGetFormatedPhoneNumber()` */
  static readonly PatientGetFormatedPhoneNumberPath = '/api/Patient';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientGetFormatedPhoneNumber()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientGetFormatedPhoneNumber$Response(params?: PatientGetFormatedPhoneNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return patientGetFormatedPhoneNumber(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientGetFormatedPhoneNumber$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientGetFormatedPhoneNumber(params?: PatientGetFormatedPhoneNumber$Params, context?: HttpContext): Observable<string> {
    return this.patientGetFormatedPhoneNumber$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `patientGetDashboardList()` */
  static readonly PatientGetDashboardListPath = '/patient/getdashbordlist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientGetDashboardList()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientGetDashboardList$Response(params?: PatientGetDashboardList$Params, context?: HttpContext): Observable<StrictHttpResponse<Dashboard>> {
    return patientGetDashboardList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientGetDashboardList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientGetDashboardList(params?: PatientGetDashboardList$Params, context?: HttpContext): Observable<Dashboard> {
    return this.patientGetDashboardList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Dashboard>): Dashboard => r.body)
    );
  }

  /** Path part for operation `patientGetPatientImage()` */
  static readonly PatientGetPatientImagePath = '/patient/GetPatientImage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientGetPatientImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientGetPatientImage$Response(params?: PatientGetPatientImage$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return patientGetPatientImage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientGetPatientImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientGetPatientImage(params?: PatientGetPatientImage$Params, context?: HttpContext): Observable<string> {
    return this.patientGetPatientImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `patientGetSignificantList()` */
  static readonly PatientGetSignificantListPath = '/patient/significantevents';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientGetSignificantList()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientGetSignificantList$Response(params?: PatientGetSignificantList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfSignificantEvents>> {
    return patientGetSignificantList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientGetSignificantList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientGetSignificantList(params?: PatientGetSignificantList$Params, context?: HttpContext): Observable<DataPageOfSignificantEvents> {
    return this.patientGetSignificantList$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfSignificantEvents>): DataPageOfSignificantEvents => r.body)
    );
  }

}
